import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [{
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('./views/News.vue'),
    },
    {
      path: '/newsdetails/:id',
      name: 'newsdetails',
      component: () => import('./views/NewsDetails.vue'),
    },
    {
      path: '/publicWelfare',
      name: 'publicWelfare',
      component: () => import('./views/PublicWelfare.vue'),
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: () => import('./views/UserAgreement.vue'),
    },
    {
      path: '/policy',
      name: 'policy',
      component: () => import('./views/Policy.vue'),
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('./views/Download.vue')
    },
    {
      path: '/welfaredetail',
      name: 'welfaredetail',
      component: () => import('./views/welfareDetail.vue'),
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: () => import('./views/AboutUs.vue')
    },
    {
      path: '/usercenter',
      name: 'usercenter',
      component: () => import('./views/VIP.vue'),
      meta: {
        hideHeader: true  // 添加元信息标识
      }
    }
  ]
})
let routerTo = null;
// 判断是否需要登录权限 以及是否登录
router.beforeEach((to, from, next) => {
  // 判断是否需要登录权限
  routerTo = to;
  if (to.matched.some(res => res.meta.requireAuth)) {
    next({
      path: '/',
      query: {
        redirect: to.fullPath
      }
    })
  } else {
    next()
  }
})

let hasError = false;
router.onError((err) => {
  if(!hasError && /Loading.*failed/.test(err.message)) {
    hasError = true;
    window.location.href = `${window.location.origin}/#${routerTo.fullPath}`;
    window.location.reload();
  }
})

export default router